import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import {ServicePercentageScheme, ServicePercentageSchemeInput} from './service-percentage-scheme.model';

export const loadServicePercentageSchemes = createAction(
  '[ServicePercentageScheme/API] Load ServicePercentageSchemes',
  props<{ servicePercentageSchemes: ServicePercentageScheme[] }>()
);

export const addServicePercentageScheme = createAction(
  '[ServicePercentageScheme/API] Add ServicePercentageScheme',
  props<{ servicePercentageScheme: ServicePercentageScheme }>()
);

export const upsertServicePercentageScheme = createAction(
  '[ServicePercentageScheme/API] Upsert ServicePercentageScheme',
  props<{ servicePercentageScheme: ServicePercentageScheme }>()
);

export const addServicePercentageSchemes = createAction(
  '[ServicePercentageScheme/API] Add ServicePercentageSchemes',
  props<{ servicePercentageSchemes: ServicePercentageScheme[] }>()
);

export const upsertServicePercentageSchemes = createAction(
  '[ServicePercentageScheme/API] Upsert ServicePercentageSchemes',
  props<{ servicePercentageSchemes: ServicePercentageScheme[] }>()
);

export const updateServicePercentageScheme = createAction(
  '[ServicePercentageScheme/API] Update ServicePercentageScheme',
  props<{ servicePercentageScheme: Update<ServicePercentageScheme> }>()
);

export const updateServicePercentageSchemes = createAction(
  '[ServicePercentageScheme/API] Update ServicePercentageSchemes',
  props<{ servicePercentageSchemes: Update<ServicePercentageScheme>[] }>()
);

export const deleteServicePercentageScheme = createAction(
  '[ServicePercentageScheme/API] Delete ServicePercentageScheme',
  props<{ id: string }>()
);

export const deleteServicePercentageSchemes = createAction(
  '[ServicePercentageScheme/API] Delete ServicePercentageSchemes',
  props<{ ids: string[] }>()
);

export const clearServicePercentageSchemes = createAction(
  '[ServicePercentageScheme/API] Clear ServicePercentageSchemes'
);

// CUSTOM
export const createServicePercentageSchemes = createAction(
  '[ServicePercentageBased/API] create ServicePercentageSchemes',
  props<{ input: ServicePercentageSchemeInput }>()
);


export const editServicePercentageSchemes = createAction(
  '[ServicePercentageBased/API] edit ServicePercentageSchemes',
  props<{ input: ServicePercentageSchemeInput }>()
);


export const removeServicePercentageSchemes = createAction(
  '[ServicePercentageBased/API] remove ServicePercentageSchemes',
  props<{ percentageUniqueId: string; id: string }>()
);

export const getServicePercentageSchemes = createAction(
  '[ServicePercentageBased/API] get ServicePercentageSchemes',
  props<{ billingUniqueId: string; }>()
);

export const citizenGetInstitutionServicePercentageSchemes = createAction(
  '[ServicePercentageBased/API] citizen get ServicePercentageSchemes',
  props<{ billingUniqueId: string; }>()
);
